import React from 'react'
import * as zod from 'zod'
import type { ToteEngagementMode } from '@mote/api'
import { useCustomForm } from '@mote/helpers/hooks/business'
import { Block, Button, Form, FormInput } from '@mote/ui'
import { useToteCardContext } from '../ToteCardProvider'
import { getMemeSrc } from '../helpers'
import { Header, StyledImage } from './Shared.styles'
import { MemeContainer } from './Teply.styles'
import { useMemeTimeout } from './useMemeTimeout'

const TEXT_AREA_STYLES = {
  width: 'auto',
  padding: 8,
  fontSize: 14,
  borderRadius: 6
}

const FORM_SCHEMA = zod.object({
  loopFeedbackText: zod
    .string({ invalid_type_error: 'Please enter at least one character' })
    .min(1, { message: 'Please enter some feedback' })
})

export interface TeplyProps {
  image: string
  mode: ToteEngagementMode
  data: {
    placeholder: string
    title: string
    onSubmit: (text: string) => void
    onSkip: () => void
  }
}

export function Teply(props: TeplyProps): JSX.Element {
  const toteCardContext = useToteCardContext()
  const shouldShowMeme = useMemeTimeout(props.image)

  const { control, handleSubmit, getValues } = useCustomForm({
    schema: FORM_SCHEMA,
    defaultValues: { loopFeedbackText: '' }
  })

  function submitForm() {
    const values = getValues()
    props.data.onSubmit(values.loopFeedbackText)
  }

  if (shouldShowMeme) {
    return (
      <MemeContainer>
        <StyledImage src={getMemeSrc(props.mode, props.image)} />
      </MemeContainer>
    )
  }

  return (
    <Form
      gap={toteCardContext.config.spacing}
      onSubmit={handleSubmit(submitForm)}
    >
      <Header {...toteCardContext.config.textStyles}>{props.data.title}</Header>
      <FormInput
        name='loopFeedbackText'
        placeholder={props.data.placeholder}
        type='textarea'
        control={control}
        inputProps={{
          style: TEXT_AREA_STYLES,
          onKeyDown: (event: React.KeyboardEvent) => {
            event.stopPropagation()
          },
          onKeyUp: (event: React.KeyboardEvent) => {
            event.stopPropagation()
          },
          onKeyPress: (event: React.KeyboardEvent) => {
            event.stopPropagation()
          }
        }}
        required
      />
      <Block layout='horizontal' gap={12} align='center' justify='flex-end'>
        <Button
          //@ts-expect-error
          size={toteCardContext.config.size}
          variant='link'
          text='Skip'
          aria-label='Skip'
          onClick={() => props.data.onSkip()}
        />
        <Button
          //@ts-expect-error
          size={toteCardContext.config.size}
          aria-label='Submit'
          text='Submit'
          htmlType='submit'
        />
      </Block>
    </Form>
  )
}
